// Browser wording for a lazy page/panel whose file no longer exists — usually a
// tab left open across a deploy, because each build renames its asset files.
const CHUNK_LOAD_PATTERNS = [
  /failed to fetch dynamically imported module/iu, // Chromium
  /error loading dynamically imported module/iu, // Firefox
  /importing a module script failed/iu, // Safari
  /unable to preload css/iu, // Vite preload helper
  /loading (?:css )?chunk [\w-]+ failed/iu,
  /expected a javascript(?:-or-wasm)? module script/iu,
];

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const { name, message } = error as { name?: unknown; message?: unknown };
  if (name === "ChunkLoadError") return true;
  return (
    typeof message === "string" && CHUNK_LOAD_PATTERNS.some((pattern) => pattern.test(message))
  );
}
